import {
  EnvironmentProviders,
  inject,
  Injectable,
  provideEnvironmentInitializer,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DrawerService } from '@ps/core-overlay';
import { TrackerConfigDrawerTriggerService } from '@ps/survey-kernel';

import { TrackerConfigDrawerComponent } from './tracker-config-drawer.component';

@Injectable({ providedIn: 'root' })
export class TrackerConfigDrawerService {
  private readonly _drawer = inject(DrawerService);
  private readonly _trigger = inject(TrackerConfigDrawerTriggerService);

  public constructor() {
    this._trigger.opened$
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.open());
  }

  public open(): void {
    this._drawer.open(TrackerConfigDrawerComponent, { size: 'auto' });
  }
}

// Forces eager creation of `TrackerConfigDrawerService` at app start — its
// constructor is what wires the kernel trigger to the drawer, and a
// `providedIn: 'root'` service otherwise stays instantiated (so the
// subscription would never exist) until something happens to inject it.
export function provideTrackerConfigDrawer(): EnvironmentProviders {
  return provideEnvironmentInitializer(() => {
    inject(TrackerConfigDrawerService);
  });
}
